import React from 'react'

function Term() {
    return (

        <div class="bg-white text-black mt-20 md:mx-40">
            <div class="container mx-auto px-4 py-8">

                <div class='w-full flex'>
                    <h1 class="text-3xl font-bold mb-4 text-orange-800">Terms of Service of NYUS </h1>
                </div>
                <br />
                <p class="mb-4 text-base">
                    Welcome to <a href='nuyseyewear.in' className='text-blue-600'>nuyseyewear.in</a> By accessing or using our Website, you agree to comply with and be bound by these Terms and Conditions. Please read them carefully before using our services.
                </p>
                <br />
                <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Acceptance of Terms</h2>
                    <p> By accessing or using our Website, you agree to be bound by these Terms and Conditions, as well as our Privacy Policy. If you do not agree with any part of these terms, you must not use our Website.</p>
                </div>
                <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'> Use of the Website</h2>
                    <p>You agree to use the Website only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the Website.
                        You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer or device.</p>
                </div>
                <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Intellectual Property</h2>
                    <p> All content on the Website, including but not limited to text, graphics, logos, images, and software, is the property of nuyseyewear.in or its content suppliers and is protected by copyright, trademark, and other laws.
                        You may not reproduce, distribute, modify, or create derivative works from any content on the Website without our prior written consent.</p>
                </div>
                <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Product Information</h2>
                    <p> We strive to provide accurate and up-to-date information about our products. However, we do not warrant that product descriptions or other content on the Website are accurate, complete, reliable, current, or error-free.
                        Prices and availability of products are subject to change without notice.</p>
                </div>
                <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Orders and Payments</h2>
                    <p>By placing an order through our Website, you are making an offer to purchase the products selected. We reserve the right to accept or reject any order at our sole discretion.
                        Payment must be made in full at the time of ordering. </p>
                </div>  <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Shipping and Delivery</h2>
                    <p> Orders will be delivered within a maximum of 7 days. Delivery times may vary based on your location and other factors.
                        We are not responsible for any delays in delivery caused by unforeseen circumstances.</p>
                </div>  <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'> Returns and Refunds</h2>
                    <p>
<strong> Refunds :</strong>  are not available for any purchases. <br></br>
<strong>Returns : </strong> Returns will only be accepted if accompanied by an unboxing video. The video must clearly demonstrate the condition of the package and its contents at the time of opening. This video serves as proof of any issues, such as damages, missing items, or incorrect products. </p>
                </div>  <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Limitation of Liability</h2>
                    <p> To the fullest extent permitted by law, nuyseyewear.in shall not be liable for any indirect, incidental, special, or consequential damages, including but not limited to loss of profits, data, or use, arising out of or in connection with the use or inability to use our Website or products.</p>
                </div>
                <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Governing Law</h2>
                    <p>These Terms and Conditions shall be governed by and construed in accordance with the laws of [Insert Jurisdiction], without regard to its conflict of law principles. </p>
                </div>
                <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Changes to Terms and Conditions</h2>
                    <p> We reserve the right to update or modify these Terms and Conditions at any time without prior notice. Your continued use of the Website following any changes constitutes your acceptance of the new terms.</p>
                </div>
                <div class='pb-5'>
                    <h2 class='font-bold text-orange-700 dark:text-orange-300'>Contact Information</h2>
                    <p> If you have any questions about these Terms and Conditions, please contact us at <a href='mailto:techsupport@nyuseyewear.in' className='text-blue-700'>techsupport@nyuseyewear.in</a> .</p>
                </div>

                <h1 class="text-xl font-bold mb-4 text-orange-800">powered by Lensplus </h1>
                
            </div>
        </div>
    )
}

export default Term
